import styled from "styled-components";

import ActiveContentWrapper from "../ActiveContentWrapper";

import HelpArticles from "./HelpArticles";
import MainOptions from "./MainOptions";
import SupportInquiryButton from "./SupportInquiryButton";

const ContactMenu = () => (
  <ActiveContentWrapper>
    <Wrapper data-cy="MemberToolbar_ContactMenuContainer">
      <Options>
        <MainOptions />
        <HelpWrapper>
          <HelpArticles />
          <SupportInquiryButton />
        </HelpWrapper>
      </Options>
    </Wrapper>
  </ActiveContentWrapper>
);

const HelpWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 4px;
`;

const Options = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export default ContactMenu;
